import Table from "@/common/elements/Table";
import { InmateDetailsTableContainer } from "@/components/InmateDetails/styles";
import DistinguishingCharacteristicsForm from "./DistinguishingCharacteristicsForm";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import Modal from "@/common/elements/Modal";
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { Popconfirm } from "antd";
import { v4 as uuidv4 } from "uuid";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const DistinguishingCharacteristics = forwardRef(
  ({ personalFormDistinguishingRef }) => {
    const dispatch = useDispatch();
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [showModal, setShowModal] = useState(false);
    const [selectDC, setSelectDC] = useState(null);
    const [dcData, setDCData] = useState([]);
    const [showEdit, setShowEdit] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    useEffect(() => {
      const dc = bookings?.bio?.[0]?.distinguishingCharacteristics;
      const dca = dc?.map((d) => {
        return {
          ...d,
          uuid: uuidv4(),
        };
      });
      setDCData(() => dca);
    }, [bookings]);

    const openModal = () => {
      setShowModal(() => true);
    };

    const closeModal = () => {
      setSelectDC(() => null);
      setShowModal(() => false);
      setShowEdit(() => false);
    };

    const selectDCDataFn = (value) => {
      setSelectDC(() => value);
      setShowEdit(() => true);
      setEmpty(() => true);
    };

    const addDc = () => {
      setSelectDC(() => null);
      setShowEdit(() => false);
      openModal();
    };

    const editDC = () => {
      openModal();
      setShowEdit(true);
    };

    const deleteDC = () => {
      let dc = dcData?.filter((p) => p?.uuid !== selectDC?.uuid);

      dispatch(
        setBookings({
          bio: [
            {
              ...bookings?.bio?.[0],
              distinguishingCharacteristics: dc,
            },
          ],
        })
      );

      if (isNonEmptyVariable(selectDC?.distinguishingCharacteristicsID)) {
        const url =
          API_ENDPOINTS?.distinguishingCharacteristics +
          "/id/" +
          selectDC?.distinguishingCharacteristicsID;
        dispatch(setDeleteAPis(url));
      }

      closeModal();
    };

    const saveClick = () => {
      personalFormDistinguishingRef?.current
        ?.validateFields()
        .then((values) => {
          let dc = dcData || [];
          const images = personalFormDistinguishingRef?.current?.getImgData();
          let updateValues = {
            ...values,
            distinguishingCharacteristicsPhotos: images?.map((i) => {
              if (isNonEmptyVariable(i?.photoId)) {
                const obj = selectDC?.distinguishingCharacteristicsPhotos?.find(
                  (d) => d?.photoId === i?.photoId
                );
                return {
                  ...obj,
                  photos: [i],
                };
              }
              return {
                photos: [i],
              };
            }),
          };
          if (showEdit) {
            dc = dc?.map((d) => {
              if (d?.uuid === selectDC?.uuid) {
                return {
                  ...d,
                  ...updateValues,
                };
              }

              return d;
            });
          } else {
            dc.push(updateValues);
          }

          dispatch(
            setBookings({
              bio: [
                {
                  ...bookings?.bio?.[0],
                  distinguishingCharacteristics: dc,
                },
              ],
            })
          );
          personalFormDistinguishingRef?.current?.setImgDataEmpty();
          personalFormDistinguishingRef?.current?.setSelectedImgEmpty();
          personalFormDistinguishingRef?.current?.resetForm();
          closeModal();
        })
        .catch((err) => {
          console.error("Validation Error:", err);
        });
    };

    const cancelAction = () => {
      setSelectDC(() => null);
      setShowEdit(() => false);
      setShowModal(() => false);
    };
    useEffect(() => {
      if (showEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [showEdit]);
    return (
      <>
        {/* {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.module,
          LABELS_CAPITAL.ADD,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS
        ) && ( */}
        <DistinguishingCharacteristicsForm
          isQuickAdd={true}
          formData={empty ? null : selectDC}
          ref={personalFormDistinguishingRef}
          quickSave={saveClick}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        />
        {/* )} */}

        <InmateDetailsTableContainer>
          {/* Header */}
          <StyledGridRow justify="end">
            <StyledGridCol style={{ paddingBottom: "15px" }}>
              <StyledFlex gap="10px">
                <Button
                  onClick={addDc}
                  disabled={
                    !bookingsFieldsEnabled ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.subModule,
                      LABELS_CAPITAL.ADD,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      SUB_MODULES_LIST_WITH_ID.Arrest_Report
                    )
                  }
                >
                  Add
                </Button>

                <Button
                  disabled={
                    !showEdit ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.subModule,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      SUB_MODULES_LIST_WITH_ID.Arrest_Report
                    )
                  }
                  onClick={editDC}
                >
                  Details
                </Button>

                <Button
                  disabled={!showEdit || !bookingsFieldsEnabled}
                  onClick={cancelAction}
                >
                  Cancel
                </Button>

                <Popconfirm
                  title="Delete the Distinguishing Characteristics"
                  description="Are you sure to delete this Distinguishing Characteristics?"
                  onConfirm={deleteDC}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    disabled={
                      !showEdit ||
                      !bookingsFieldsEnabled ||
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.DELETE,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Arrest_Report
                      )
                    }
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </StyledFlex>
            </StyledGridCol>
          </StyledGridRow>

          {hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report
          ) && (
            <Table
              headers={[
                { key: "characteristicType", text: "Characteristic Type" },
                { key: "nist", text: "NIST" },
                { key: "location", text: "Location" },
                { key: "description", text: "Description" },
              ]}
              data={dcData}
              onRowClick={selectDCDataFn}
              onRowDoubleClick={(value) => {
                selectDCDataFn(value);
                editDC();
              }}
              selected={selectDC === null}
            />
          )}
        </InmateDetailsTableContainer>

        {showModal && (
          <Modal
            header="Distinguishing Characteristics"
            show={showModal}
            designPattern="ant"
            onHide={closeModal}
            handleSubmit={saveClick}
            handleCancel={closeModal}
            width={"50%"}
            submitButtonDisabled={bookingsFieldsEnabled}
            hideSubmitButton={isDisabled}
          >
            <DistinguishingCharacteristicsForm
              isQuickAdd={false}
              formData={selectDC}
              ref={personalFormDistinguishingRef}
              bookingsFieldsEnabled={bookingsFieldsEnabled}
              isEdit={showEdit}
            />
          </Modal>
        )}
      </>
    );
  }
);
export default DistinguishingCharacteristics;
